
import React, { useRef } from 'react'
import { MdOutlineEmojiEvents, MdOutlineFamilyRestroom, MdOutlineShoppingCartCheckout, MdOutlineWaterfallChart, MdOutlineCardTravel, MdSurfing, MdChevronLeft, MdChevronRight } from "react-icons/md";
import { PiHairDryerThin } from "react-icons/pi";
import { IoRestaurantSharp } from "react-icons/io5";
import { CiShoppingBasket } from "react-icons/ci";
import { HiOutlineHomeModern } from "react-icons/hi2";
import { TbChartBarPopular } from "react-icons/tb";
import { Link } from 'react-router-dom';

const MainCategories = () => {
    const scrollRef = useRef(null);

    const scroll = (dir) => {
        if (scrollRef.current) {
            scrollRef.current.scrollBy({ left: dir * 300, behavior: 'smooth' });
        }
    };

    const categories = [
        { name: 'Activities & Events', link: 'activities-and-events', image: MdOutlineEmojiEvents },
        { name: 'Beauty & Wellness', link: 'baeauty-and-wellness', image: PiHairDryerThin },
        { name: 'Family', link: 'family', image: MdOutlineFamilyRestroom },
        { name: 'Restaurants', link: 'restaurants', image: IoRestaurantSharp },
        { name: 'Groceries', link: 'groceries', image: CiShoppingBasket },
        { name: 'Home & Autos', link: 'home-and-autos', image: HiOutlineHomeModern },
        { name: 'Shopping', link: 'shopping', image: MdOutlineShoppingCartCheckout },
        { name: 'Niagara', link: 'niagara', image: MdOutlineWaterfallChart },
        { name: 'Travel', link: 'travel', image: MdOutlineCardTravel },
        { name: 'Things To Do', link: 'things-to-do', image: MdSurfing },
        { name: 'Popular', link: 'popular', image: TbChartBarPopular },
    ];

    return (
        <div className='main-categories'>
            <div className="container">
                <div className="categories-row">
                    <button className="cat-scroll-btn" onClick={() => scroll(-1)} aria-label="Scroll left">
                        <MdChevronLeft />
                    </button>
                    <div className="categories-scroll" ref={scrollRef}>
                        {categories.map((cat, id) => (
                            <Link to={`categories/${cat.link}`} className="cat-item" key={id}>
                                <div className="cat-icon">
                                    <cat.image />
                                </div>
                                <div className="cat-title">{cat.name}</div>
                            </Link>
                        ))}
                    </div>
                    <button className="cat-scroll-btn" onClick={() => scroll(1)} aria-label="Scroll right">
                        <MdChevronRight />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default MainCategories